// extracted by mini-css-extract-plugin
module.exports = {"img":"Noun_img__1GJxo","imgWrapper":"Noun_imgWrapper__1EdkS","traitWrapper":"Noun_traitWrapper__3iWee"};